import type { ImportedDocumentPayload } from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One document imported into a dossier. The converted text is never carried.
 */
class ImportedDocumentView {
	readonly id: number;
	readonly name: string;
	readonly description: string | null;
	readonly format: LabeledValueView;
	readonly status: LabeledValueView;
	/** Why the conversion failed, in French; non-null only when `isFailed`. */
	readonly failureMessage: string | null;
	readonly importedAt: Date;
	readonly importedById: number | null;
	readonly convertedAt: Date | null;

	constructor(payload: ImportedDocumentPayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.description = payload.description;
		this.format = new LabeledValueView(payload.format);
		this.status = new LabeledValueView(payload.status);
		this.failureMessage = payload.failureMessage;
		this.importedAt = new Date(payload.importedAt);
		this.importedById = payload.importedBy?.id ?? null;
		this.convertedAt = payload.convertedAt === null ? null : new Date(payload.convertedAt);

		Object.freeze(this);
	}

	get isConverting(): boolean {
		return this.status.value === 'converting';
	}

	get isReady(): boolean {
		return this.status.value === 'ready';
	}

	get isFailed(): boolean {
		return this.status.value === 'failed';
	}
}

export default ImportedDocumentView;
